import { type VendorsType } from '../../types/vendors'
import { FaguadalajaraFormSchema } from './schemas'

export const vendors: Record<
	VendorsType,
	{
		label: string
		active: boolean
		action?: any
		schema?: any
	}
> = {
	walmart: {
		label: 'Walmart',
		active: true,
	},
	oxxo: {
		label: 'Oxxo',
		active: false,
	},
	fahorro: {
		label: 'Farmacias del Ahorro',
		active: true,
	},
	faguadalajara: {
		label: 'Farmacias Guadalajara',
		active: true,
		schema: FaguadalajaraFormSchema,
	},
	fasimilares: {
		label: 'Farmacias Similares',
		active: true,
	},
	officemax: {
		label: 'Office Max',
		active: true,
	},
	costco: {
		label: 'Costco',
		active: true,
	},
}
